import { useRef } from "react";

const useId = (idPrefix = "toddle") => {
  const idRef = useRef(null);

  if (idRef.current === null) {
    // Generate a random ID
    idRef.current = `${idPrefix}_${Math.random().toString(36).slice(2, 9)}`;
  }

  return idRef.current;
};

export default useId;
